var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Error({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230px",
    height: "96px",
    viewBox: "0 0 230 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0F085129-A745-4588-859C-CEF99E9BF418") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7175989,95.1999984 L61.7175989,72.4303988 L72.6529988,72.4303988 L72.6529988,55.6527991 L61.7175989,55.6527991 L61.7175989,0.0769999987 L34.7535994,0.0769999987 L0,57.300599 L0,72.4303988 L41.1949993,72.4303988 L41.1949993,95.1999984 L61.7175989,95.1999984 Z M41.1949993,55.6527991 L21.1217996,55.6527991 L33.7049994,34.9803994 C35.1031327,32.2839995 36.4513327,29.5875995 37.7495994,26.8911995 C39.047866,24.1947996 40.2961993,21.548333 41.4945993,18.9517997 L41.4945993,18.9517997 L42.0937993,18.9517997 C41.894066,21.9477996 41.6943326,25.4680996 41.4945993,29.5126995 C41.294866,33.5572994 41.1949993,37.1275327 41.1949993,40.2233993 L41.1949993,40.2233993 L41.1949993,55.6527991 Z",
    id: 4,
    fill: "#035073",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.517596,95.1999984 L218.517596,72.4303988 L229.452996,72.4303988 L229.452996,55.6527991 L218.517596,55.6527991 L218.517596,0.0769999987 L191.553597,0.0769999987 L156.799997,57.300599 L156.799997,72.4303988 L197.994997,72.4303988 L197.994997,95.1999984 L218.517596,95.1999984 Z M197.994997,55.6527991 L177.921797,55.6527991 L190.504997,34.9803994 C191.90313,32.2839995 193.25133,29.5875995 194.549597,26.8911995 C195.847863,24.1947996 197.096197,21.548333 198.294597,18.9517997 L198.294597,18.9517997 L198.893797,18.9517997 C198.694063,21.9477996 198.49433,25.4680996 198.294597,29.5126995 C198.094863,33.5572994 197.994997,37.1275327 197.994997,40.2233993 L197.994997,40.2233993 L197.994997,55.6527991 Z",
    id: 4,
    fill: "#0A87A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.799998,0 C141.944375,0 152.599997,21.3112455 152.599997,47.5999992 C152.599997,73.6258653 142.156422,94.7732757 129.193574,95.1936213 L128.799998,95.1999984 L102.899998,95.1999984 C116.044375,95.1999984 126.699998,73.8887528 126.699998,47.5999992 C126.699998,21.3112455 116.044375,0 102.899998,0 L128.799998,0 Z",
    id: "Combined-Shape",
    fill: "#0C87A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.899998,0 C107.675788,0 112.123036,2.8133212 115.850023,7.65653162 C109.319196,16.1432581 104.999998,30.862826 104.999998,47.5999992 C104.999998,64.3371723 109.319196,79.0567402 115.849973,87.5434668 C112.123036,92.3866772 107.675788,95.1999984 102.899998,95.1999984 C89.7556214,95.1999984 79.0999987,73.8887528 79.0999987,47.5999992 C79.0999987,21.3112455 89.7556214,0 102.899998,0 Z",
    id: "Combined-Shape",
    fill: "#055073"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(139.500000, 36.300781) rotate(-180.000000) translate(-139.500000, -36.300781) ",
    points: "121 20 157.021729 42.7832031 158 52.6015625 121 29.3139648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    points: "75.5610352 41.5908203 111.582764 64.3740234 112.561035 74.1923828 75.5610352 50.9047852"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404-error.b59f746e0e64c04b0fdb886e3212d8c8.svg";
export { ForwardRef as ReactComponent };